<template>
	<div class="funnel-choice-card">
		<div class="card-top">
			<div class="card-heading">
				<div class="card-title-row">
					<div class="card-number">{{ number }}</div>
					<h4 class="card-title">{{ title }}</h4>
				</div>
				<div class="card-img">
					<img :src="image" :alt="title" />
				</div>
			</div>
			<div class="card-text">
				<p class="card-lead" v-html="lead"></p>
				<div class="card-bullets">
					<div class="card-bullet" v-for="(bullet, index) in bullets" :key="index">
						<span class="bullet-dot"></span>
						<p class="bullet-text" v-html="bullet"></p>
					</div>
				</div>
			</div>
		</div>
		<AppButton class="card-cta" :text="ctaText" @click="$emit('choose')" />
	</div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";

export default {
	name: "FunnelChoiceCard",
	components: {AppButton},
	emits: ["choose"],
	props: {
		number: {type: [Number, String], required: true},
		title: {type: String, required: true},
		image: {type: String, required: true},
		lead: {type: String, default: ""},
		bullets: {type: Array, default: () => []},
		ctaText: {type: String, required: true},
	},
}
</script>

<style lang="scss" scoped>
.funnel-choice-card {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 20px;
	flex: 1 1 0;
	min-width: 0;
	max-width: 400px;
	padding: 15px;
	border-radius: 13px;
	background-color: var(--color-bg);
	box-shadow: 5px 5px 10px rgba(var(--rgb-primary), .2),
				inset -1px -1px 4px rgba(var(--rgb-primary), .5);

	.card-top {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
	}

	.card-heading {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;
	}

	.card-title-row {
		display: flex;
		align-items: center;
		gap: 10px;
		width: 100%;
	}

	.card-number {
		@include centered;
		flex-shrink: 0;
		width: 30px;
		height: 30px;
		border-radius: 20px;
		background-color: rgba(var(--rgb-primary), .1);
		border: 1px solid rgba(var(--rgb-primary), .4);
		font-size: 18px;
		font-weight: 700;
		line-height: 18px;
		color: var(--color-primary);
	}

	.card-title {
		font-size: 20px;
		font-weight: 700;
		color: var(--color-primary);
	}

	.card-img {
		@include centered;
		width: 100%;
		height: 150px;
		border-radius: 13px;
		overflow: hidden;
		background-color: rgba(var(--rgb-primary), .05);
		box-shadow: inset 2px 2px 5px rgba(var(--rgb-primary), .4);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.card-text {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
	}

	.card-lead {
		font-size: 18px;
		color: var(--color-txt);

		:deep(b), :deep(strong) { font-weight: 700; }
	}

	.card-bullets {
		display: flex;
		flex-direction: column;
		gap: 14px;
		width: 100%;
	}

	.card-bullet {
		display: flex;
		align-items: flex-start;
		gap: 10px;

		.bullet-dot {
			flex-shrink: 0;
			width: 7px;
			height: 7px;
			margin-top: 7px;
			border-radius: 50%;
			background-color: var(--color-primary);
		}

		.bullet-text {
			font-size: 14px;
			line-height: 16px;
			color: var(--color-txt);

			:deep(b), :deep(strong) { font-weight: 700; }
		}
	}

	.card-cta {
		width: 100%;
		max-width: 100%;
		:deep(.base-button) {
			width: 100%;
			max-width: unset;
		}
	}
}
</style>
